'use client';

import { Button } from '@petsmart-ui/sparky';

import { useOptimizely } from '@libs/common-next';

import { useMiniPdpDrawer } from './model/use-mini-pdp-drawer';
import type { MiniPdpDrawerOptions as MiniPdpCTAProps } from './types';

export function MiniPdpCTA({ productId, source }: Readonly<MiniPdpCTAProps>) {
    const open = useMiniPdpDrawer(state => state.open);
    const { context } = useOptimizely();

    if (!productId) return null;

    return (
        <Button
            text="Add to cart"
            fullWidth
            onClick={event => {
                event.stopPropagation();
                context?.trackEvent('_optex_US-CA_ymal-add-to-cart-click_FXE_pdp_s_852');
                open({ productId, source });
            }}
            data-testid="mini-pdp-cta"
        />
    );
}
